module.exports = __webpack_public_path__ + "img/IMG_6689_L_Black.8583c71d.jpg";